import {useEffect, useState} from "react";

import api from "../../../../api.js";
import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {StockOnHand} from "@/variants/index.js";

import styles from "./StockOnHandTab.module.css";

export const StockOnHandTab = ({item, data = [], calcStockData}) => {
	const [keys, setKeys] = useState();
	const [showAll, setShowAll] = useState(StockOnHand.getShowAll() || false);

	function getColumns(columns) {
		if (keys) {
			return columns.filter(column => keys.includes(column["key"]));
		} else {
			return columns;
		}
	}

	useEffect(() => {
		api.get("/settings/columns?table=Stock-on-Hand")
			.then(json => setKeys(json.data))
			.catch(console.log);
	}, []);

	return (
		<div>
			<div className={styles.beautifulLink} onClick={() => setShowAll(!showAll)}>
				{showAll ? "Hide" : "Show"} zero-stock locations
			</div>
			<AntdTable
				tableSize={"small"}
				scroll={280}
				data={StockOnHand.getFullRows(data, showAll, item, calcStockData)}
				columns={getColumns(StockOnHand.getColumns(data))}
				data-testid="stock-on-hand-table"
			/>
		</div>
	);
};
